import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { id: "scroll-container" }
const _hoisted_2 = { id: "page-container" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h1", null, "musictools", -1)
const _hoisted_4 = { id: "navbar" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode("Tools")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("About")
const _hoisted_7 = { id: "user-container" }
const _hoisted_8 = { class: "menu" }
const _hoisted_9 = { class: "menu-head" }
const _hoisted_10 = /*#__PURE__*/_createTextVNode("Not signed in")
const _hoisted_11 = { class: "menu-content" }
const _hoisted_12 = { class: "menu-head" }
const _hoisted_13 = { class: "menu-head" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("footer", null, [
  /*#__PURE__*/_createElementVNode("p", null, [
    /*#__PURE__*/_createTextVNode(" Made with "),
    /*#__PURE__*/_createElementVNode("a", { href: "https://v3.vuejs.org/" }, "Vue 3"),
    /*#__PURE__*/_createTextVNode(". Available under the "),
    /*#__PURE__*/_createElementVNode("a", { href: "https://www.gnu.org/licenses/gpl-3.0.en.html" }, "GNU General Public License"),
    /*#__PURE__*/_createTextVNode(". ")
  ])
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_OctocatCorner = _resolveComponent("OctocatCorner")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("header", null, [
        _hoisted_3,
        _createElementVNode("section", _hoisted_4, [
          _createElementVNode("nav", null, [
            _createVNode(_component_router_link, { to: "/" }, {
              default: _withCtx(() => [
                _hoisted_5
              ]),
              _: 1
            }),
            _createVNode(_component_router_link, { to: "/about" }, {
              default: _withCtx(() => [
                _hoisted_6
              ]),
              _: 1
            })
          ]),
          _createElementVNode("nav", _hoisted_7, [
            _createElementVNode("ul", null, [
              _createElementVNode("li", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, [
                  (_ctx.authenticatedServices.length !== 0)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createTextVNode(" Signed in to " + _toDisplayString(_ctx.authenticatedServices.join(", ")), 1)
                      ], 64))
                    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        _hoisted_10
                      ], 64))
                ]),
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("ul", null, [
                    _createElementVNode("li", null, [
                      _createElementVNode("div", _hoisted_12, [
                        (_ctx.spotifyCurrentUser)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                              _createTextVNode(" Signed in to Spotify as " + _toDisplayString(_ctx.spotifyUsername) + " ", 1),
                              _createElementVNode("span", {
                                class: "sign-in",
                                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.spotifyLogout && _ctx.spotifyLogout(...args)))
                              }, "(sign out)")
                            ], 64))
                          : (_openBlock(), _createElementBlock("span", {
                              key: 1,
                              class: "sign-in",
                              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.spotifyLogin && _ctx.spotifyLogin(...args)))
                            }, "Sign in to Spotify"))
                      ]),
                      _createElementVNode("div", _hoisted_13, [
                        (_ctx.lastfmCurrentUser)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                              _createTextVNode(" Last.fm user: " + _toDisplayString(_ctx.lastfmCurrentUser) + " ", 1),
                              _createElementVNode("span", {
                                class: "sign-in",
                                onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.lastfmLogin && _ctx.lastfmLogin(...args)))
                              }, "(change)")
                            ], 64))
                          : (_openBlock(), _createElementBlock("span", {
                              key: 1,
                              class: "sign-in",
                              onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.lastfmLogin && _ctx.lastfmLogin(...args)))
                            }, "Set Last.fm username"))
                      ])
                    ])
                  ])
                ])
              ])
            ])
          ])
        ]),
        _hoisted_14
      ]),
      _createVNode(_component_OctocatCorner),
      _createVNode(_component_router_view),
      _hoisted_15
    ])
  ]))
}